export var ApiLoginWarning;
(function (ApiLoginWarning) {
    ApiLoginWarning["EMAIL_VERIFICATION"] = "email verification";
})(ApiLoginWarning || (ApiLoginWarning = {}));
